import { render, staticRenderFns } from "./add_property.vue?vue&type=template&id=51b351d7"
import script from "./add_property.vue?vue&type=script&lang=js"
export * from "./add_property.vue?vue&type=script&lang=js"
import style1 from "./add_property.vue?vue&type=style&index=1&id=51b351d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports